import React from 'react'
import PropTypes from 'prop-types'

const DisabledOverlay = (props) => {
    return (
        <div className={`disabled-overlay ${props.isDisabled ? 'disabled' : ''}`}>
            <div className='overlay-container' />
            {props.children}
        </div>
    )
}

DisabledOverlay.propTypes = {
    isDisabled: PropTypes.bool.isRequired
}

DisabledOverlay.defaultProps = {
    isDisabled: false
}

export default DisabledOverlay



// WEBPACK FOOTER //
// ./resources/js/components/DisabledOverlay.js